import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateCentroCustoSecundarioUseCase } from "../../../presentation/useCases/create/create_centro_custo_secundario_use_case";

// CreateCentroCustoSecundarioUseCase


export class CreateCentroCustoSecundarioUseCase implements ICreateCentroCustoSecundarioUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createCentroCustoSecundario(
    idFuncionario: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.repository.createCentroCustoSecundario(idFuncionario, idCentroCusto,
    );
  }
}
